// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues, { BreakpointValue } from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export const boxStyles = (padding: BreakpointValue[] | null = pxToRemArray([25, 32, 40])) => css`
    width: 100%;
    border: ${pxToRem(3)} solid ${getColor("common.borderLight")};
    ${padding ? breakpointValues(padding, "padding") : null}
`;

export const boxSignInStyles = () => css`
    ${breakpoint("md")} {
        ${boxStyles(pxToRemArray([null, null, 20, 32, 48]))};
        height: 100%;
    }
`;

export const boxStickyStyles = () => css`
    padding: ${pxToRem(10)};
    box-shadow: ${props => props.theme.shadows.e60Up};
    background-color: ${getColor("common.background")};
`;
